<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" /> 


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Participante</label>
                <div class="field-label">{{ objView.nmpessoa }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdpessoa) }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Programa</label>
                <div class="field-label">{{ objView.nmprograma }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome Fornecedor</label>
                <div class="field-label">{{ objView.nmfornecedor }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdfornecedor) }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Situação Documento</label>
                <div class="field-label">{{ objView.nmstatus }}</div>
            </div>
        </div>

        
        <div class="row">
            <div class="form-item-char10">
                <label class="label-caption">Modelo</label>
                <div class="field-label field-label-center">{{ objView.dfmodelo }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Tipo</label>
                <div class="field-label field-label-center">{{ objView.tpnota }}</div>
            </div>

            <div class="form-item-char05">
                <label class="label-caption">Série</label>
                <div class="field-label field-label-end">{{ objView.dfserie }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Número</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.dfnumero) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Chave</label>
                <div class="field-label">{{ objView.dfchave }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Data Registro</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtregistro) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Valor R$</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.dfvalor) }}</div>
            </div>
        </div>
    </div>

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Justificativa (Obrigatório para cancelamento)</label>
                <input type="text" v-model="edJustificativa" maxlength="100" v-uppercase />
            </div>

            <div v-if="!ckValorAutorizado" class="form-item-char20">
                <label class="label-caption">Valor a Corrigir</label>
                <input v-model="edVlCorrecao" v-decimal type="text" class="input-right" />
            </div>
        </div>


        <div class="row-end row-space">
            <label for="ckValorAutorizado">VALOR DIGITADO CORRETAMENTE</label>
            <input id="ckValorAutorizado" type="checkbox" class="input-checkbox" v-model="ckValorAutorizado" />
        </div>

        
        <div class="row-end">
            <button v-if="objView.tipoAnexo !== 'imagem'" @click="abrirAnexo">Visualizar/Download</button>
            <button class="btn-confirm" @click="homologar(true)">AUTORIZAR</button>
            <button class="btn-cancel" @click="homologar(false)">CANCELAR</button>
            <button @click="closeForm">Retornar</button>
        </div>
    </div>


    <div v-if="objView.tipoAnexo === 'imagem'" class="form-edit-page">
        <div class="row-center">
            <div v-if="objView.tipoAnexo === 'imagem'">
                <img class="img-anexo" v-if="objView.linkAnexo" :src="objView.linkAnexo" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idView: {type: Number, default: 0}});

const ckValorAutorizado = ref(false);
const edJustificativa = ref(null);
const edVlCorrecao = ref(null);
const isLoading = ref(false);
const msgAlerta = ref(false);
const objView = ref({});


function abrirAnexo() {
    if (objView.value.linkAnexo) {
        window.open(objView.value.linkAnexo, '_blank');
    }
}


function closeForm() {emit('close');}


async function downloadAnexo() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;

        if (objView.value.idanexo) {
            const blob = await Api.genericAnexo(objView.value.idanexo);
            const url = URL.createObjectURL(blob);
            objView.value.linkAnexo = url;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function homologar(opcao){
    try{
        msgAlerta.value = null;
        if ((!opcao) && (!edJustificativa.value)){msgAlerta.value='Informe a justificativa'; return;}
        if ((opcao) && (!ckValorAutorizado.value) && (!Funcoes.decimalFromString(edVlCorrecao.value)>0)){
            msgAlerta.value = 'Informe valor a ser corrigido ou marque opção de valor correto'; return;
        }
        isLoading.value = true;
        const response = await Api.genericPost('/main/exec_requisicao', {
            nmrequisicao: 'nota_homologacao',
            id: objView.value.id,
            strparam1: edJustificativa.value,
            intparam1: opcao ? 1 : 9,
            double1: ckValorAutorizado.value ? 0 : Funcoes.decimalFromString(edVlCorrecao.value),
            idlogin: globalStore.idlogin});
        if (response.bolok===1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = `ATENÇÃO: ${response.erro}`
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function lerDados() {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/notas', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);

        if (objView.value.url_anexo){
            objView.value.linkAnexo = objView.value.url_anexo;

            const extensao = objView.value.url_anexo.split('.').pop().toLowerCase();
            const formatosImagem = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];

            if (formatosImagem.includes(extensao)) {
                objView.value.tipoAnexo = 'imagem';
            } else {
                objView.value.tipoAnexo = 'outro';
            }
        }else{
            objView.value.tipoAnexo = 'imagem';
            await downloadAnexo(); // FUNÇÃO QUE BAIXA OU MONTA O LINK PARA IMAGEM
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


onMounted(lerDados);
</script>

<style scoped>
.img-anexo {
    max-width: 100%;   /* nunca ultrapassa a largura do container */
    height: auto;      /* mantém proporção da imagem */
    display: block;    /* evita espaços extras */
    margin: 0 auto;    /* centraliza horizontalmente */
}
</style>